<div class="container-fluid p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">Upload Responses</h4>
        <h5 class="text-primary">[{{ proposalName}}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container *ngIf="
            stepDetails?.is_initiator ||
            stepDetails?.is_approver ||
            stepDetails?.is_recommender ||
            (stepDetails?.step_status != 'approved' && userID == 6)
          ">
          <button class="btn btn-primary me-2" (click)="submitCsv()" [disabled]="!csvfile">
            <i class="pi pi-save me-1"></i> Save
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_initiator">
          <button class="btn btn-success" (click)="IRA.emit('Initiate')">
            <i class="pi pi-play me-1"></i> Initiate
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_approver">
          <button class="btn btn-success" (click)="IRA.emit('Approve')">
            <i class="pi pi-check-circle me-1"></i> Approve
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_recommender">
          <button class="btn btn-info" (click)="IRA.emit('Recommend')">
            <i class="pi pi-thumbs-up me-1"></i> Recommend
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />
  <div class="container-fluid mt-4">
    <!-- <div class="d-flex justify-content-start mb-3">
      <button class="fetch-data-btn h-35px" (click)="downloadSampleCsv()">
        Download Sample CSV
      </button>
    </div> -->

    <!-- <div class="row mb-4">
      <div class="col-lg-8">
        <div class="card shadow-sm border-0">
          <div class="card-body p-4">
            <div class="d-flex align-items-center mb-3">
              <i class="pi pi-file text-primary me-2"></i>
              <h5 class="card-title mb-0">Upload CSV</h5>
            </div>
            <p class="text-muted mb-4">Please upload your document in CSV format (Max size: 200MB)</p>
            <div class="upload-container mb-4"
              *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender || (stepDetails?.step_status != 'approved' && userID == 6)">
              <div class="upload-area p-4 text-center border rounded">
                <p-fileUpload mode="basic" chooseLabel="Browse Files" (uploadHandler)="onCsvUpload($event)"
                  [auto]="true" [customUpload]="true" #fileUpload [multiple]="false"
                  [accept]="'.csv'" [maxFileSize]="209715200"
                  styleClass="p-button-rounded p-button-outlined">
                </p-fileUpload>
              </div>
            </div>

            <div *ngIf="uploadedFileName || uploadedUrl">
              <div class="uploaded-file-card p-3 bg-light rounded d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <i class="pi pi-file me-3 text-primary" style="font-size: 1.5rem;"></i>
                  <div>
                    <p class="mb-0 fw-semibold">
                      <a [href]="apiUrl + uploadedUrl" target="_blank" class="text-decoration-none">
                        {{ uploadedFileName || getFileName(uploadedUrl) }}
                      </a>
                    </p>
                    <small class="text-muted">Uploaded successfully</small>
                  </div>
                </div>
                <div class="d-flex gap-2">
                  <a [href]="apiUrl + uploadedUrl" target="_blank" class="btn btn-sm btn-outline-primary"
                    *ngIf="uploadedUrl">
                    <i class="pi pi-eye"></i>
                  </a>

                  <i class="pi pi-times" (click)="clearUpload(fileUpload)" *ngIf="uploadedFileName"></i>

                </div>
              </div>
            </div>

            <div *ngIf="!uploadedFileName && !uploadedUrl && 
                      !(stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender || 
                      (stepDetails?.step_status != 'approved' && userID == 6))"
              class="no-file-placeholder p-3 text-center bg-light rounded">
              <i class="pi pi-inbox text-muted mb-2" style="font-size: 1.5rem;"></i>
              <p class="mb-0 text-muted">No files uploaded</p>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <app-upload-document></app-upload-document> -->
    <form class="proposal-form-container mb-2">
      <div class="form-container">
        <!-- === File Upload Section === -->
        <div class="form-section">
          <div class="section-header" (click)="toggleSection('uploads')">
            <h3 class="section-title">
              Document Uploads
              <i class="pi" [ngClass]="expandedSections['uploads'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </h3>
          </div>
          <!-- File Uploads Section -->
          <div class="section-content mt-2" *ngIf="expandedSections['uploads']">
            <app-upload-document (uploadData)="onDocumentUpload($event)" [dmsFiles]="allDmsFiles"
              (documentEdited)="onDocumentEdited($event)" (documentDeleted)="onDocumentDeleted($event)">
            </app-upload-document>
          </div>
        </div>

        <!-- Vendor Table Section -->
          <div class="form-section">
            <div class="section-header" (click)="toggleSection('vendorTable')">
              <h3 class="section-title">
                Vendor Table
                <i class="pi" [ngClass]="expandedSections['vendorTable'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
              </h3>
            </div>
            <div class="section-content mt-2" *ngIf="expandedSections['vendorTable']">
              <div class="d-flex justify-content-end mb-3 gap-3">
                <button class="fetch-data-btn h-35px" (click)="addVendor()">Add Vendor</button>
              </div>
              <p-table [value]="vendors" dataKey="id" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Sr. No.</th>
                    <th>Applicant Name</th>
                    <th>Company Name</th>
                    <th>Contact Person</th>
                    <th>Address</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>GST Number</th>
                    <th>Bank</th>
                    <th>Document</th>
                    <th>Action</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-vendor let-rowIndex="rowIndex">
                  <tr>
                    <td>{{ rowIndex + 1 }}</td>

                    <!-- Applicant Name -->
                    <td>
                      <input *ngIf="vendor.isEditing" type="text" pInputText [(ngModel)]="vendor.name" />
                      <span *ngIf="!vendor.isEditing">{{ vendor.name }}</span>
                    </td>

                    <!-- Company Name -->
                    <td>
                      <input *ngIf="vendor.isEditing" type="text" pInputText [(ngModel)]="vendor.company_name" />
                      <span *ngIf="!vendor.isEditing">{{ vendor.company_name }}</span>
                    </td>

                    <!-- Contact -->
                    <td>
                      <input *ngIf="vendor.isEditing" type="text" pInputText [(ngModel)]="vendor.contact" />
                      <span *ngIf="!vendor.isEditing">{{ vendor.contact }}</span>
                    </td>

                    <!-- Address -->
                    <td>
                      <input *ngIf="vendor.isEditing" type="text" pInputText [(ngModel)]="vendor.address" />
                      <span *ngIf="!vendor.isEditing">{{ vendor.address }}</span>
                    </td>

                    <!-- Email -->
                    <td>
                      <input *ngIf="vendor.isEditing" type="email" pInputText [(ngModel)]="vendor.email" />
                      <span *ngIf="!vendor.isEditing">{{ vendor.email }}</span>
                    </td>

                    <!-- Phone -->
                    <td>
                      <input *ngIf="vendor.isEditing" type="text" pInputText [(ngModel)]="vendor.phone_number" maxlength="10"
                        minlength="10" (keypress)="allowOnlyNumbers($event)" />
                      <span *ngIf="!vendor.isEditing">{{ vendor.phone_number }}</span>
                    </td>

                    <!-- GST -->
                    <td>
                      <input *ngIf="vendor.isEditing" type="text" pInputText [(ngModel)]="vendor.tax_number" />
                      <span *ngIf="!vendor.isEditing">{{ vendor.tax_number }}</span>
                    </td>

                    <!-- Bank -->
                    <td>
                      <input *ngIf="vendor.isEditing" type="text" pInputText [(ngModel)]="vendor.bank_details" />
                      <span *ngIf="!vendor.isEditing">{{ vendor.bank_details }}</span>
                    </td>
                    <td>
                      <!-- Editing / Adding -->
                      <div *ngIf="vendor.isEditing">
                        <!-- Upload control -->
                        <p-fileUpload mode="basic" name="docs[]" chooseLabel="Upload" [maxFileSize]="209715200" [auto]="false"
                          [accept]="'.pdf,.docx,.jpeg,.jpg,.png'" [customUpload]="true" [showUploadButton]="false"
                          [showCancelButton]="false" [multiple]="true" (onSelect)="onSelectFile($event, vendor)">
                        </p-fileUpload>
                        <!-- Show current uploaded docs if available -->
                        <div *ngIf="vendor.document">
                          <a [href]="apiUrl + vendor.document" target="_blank">
                            {{ getFileName(vendor.document) }}
                          </a>
                        </div>
                      </div>
                      <!-- View Only (not editing) -->
                      <div *ngIf="!vendor.isEditing">
                        <ng-container *ngIf="vendor.document; else noDoc">
                          <a [href]="apiUrl + vendor.document" target="_blank">
                            {{ getFileName(vendor.document) }}
                          </a>
                        </ng-container>
                        <ng-template #noDoc>
                          <span>No document uploaded</span>
                        </ng-template>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center gap-2">
                        <button *ngIf="vendor.isEditing" class="fetch-data-btn" (click)="saveVendor(vendor)">Save</button>
                        <button *ngIf="!vendor.isEditing" class="p-button-warning" (click)="toggleEdit(vendor)">Edit</button>
                        <button class="p-button-danger" (click)="removeVendor(vendor)">Cancel</button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
      </div>
    </form> 
  </div>
</div>